import * as React from 'react'
import './../css/dotLoader.css'

export const DotLoader = () => {
  return (
    <div className="dot-loader__container">
      <div className="ball"></div>
      <div className="ball"></div>
      <div className="ball"></div>
      <div className="ball"></div>
      <div className="ball"></div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/dotLoader.tsx